import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlDateTime } from '../ControlDateTime'

import { control } from './control'

/**
 * @param {string} name
 * @param {Date} value
 * @param {Object} defaultProps
 */
export function dateTime(name, value, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlDateTime, defaultProps)
}
